<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="代理商名称：">
                <el-input v-model.trim="searchForm.agentName"  @keyup.enter.native="getPrechargeOrderListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="下单时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getPrechargeOrderListHandler" plain icon="el-icon-search">搜索查询</el-button>
                 <el-button type="success"  plain @click="exportOrderInfoHandle">导出Excel</el-button>
                <!-- <el-button type="success" @click="AliPayVisible = true" plain>充值</el-button> -->
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" 
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		>
            <!-- <el-table-column type="index" label="序号"></el-table-column>       -->
            <el-table-column prop="orderNo" label="ID"></el-table-column>
            <el-table-column prop="agentName" label="代理商" width="160"></el-table-column>
              <el-table-column  align="center"  label="预充值金额" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.payStateName">
                        <p style="color:#0000FF"> {{scope.row.priceRmb}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <!-- <el-table-column prop="payTypeName" label="充值来源" ></el-table-column> -->
            <el-table-column prop="createOptName" label="充值人" ></el-table-column>
            <el-table-column prop="createTime" label="充值时间" ></el-table-column>
            <el-table-column prop="investStateName" label="充值状态" width="120"></el-table-column>
            <el-table-column  align="center"  label="支付状态">
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState==1" class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:green"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.payState==3||scope.row.payState==4" class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:red"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.payNo">
                        <p style="color:teal"> {{scope.row.payStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="充值备注" width="600" ></el-table-column>
        </el-table>
                 
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

        <el-dialog :append-to-body="true"  title="微信充值" :visible.sync="AliPayVisible"  width="400px" @close="cancelToPay" :close-on-click-modal="false">
            <div class="AliPayIcon">
                <div>
                   <img src="@/assets/alipay.png"> 
                </div>
            </div>
            <p>充值金额（元）</p>
            <div class="priceDiv">
                <span class="priceIcon">￥</span>
                <input class="priceRmbInput"  v-model.trim="priceRmb" 
                @keyup="formatPrice()" 
                @blur="formatPrice()" 
                placeholder="请输入充值金额">
            </div>
            <div class="topUpBtn" @click="doAddOrder">充 值</div>
            
        </el-dialog> 
        <el-dialog
width="30%"
:title="payment"
@close="closeCode"
:visible.sync="innerVisible"
append-to-body>
<div class="AliPayIcon" >
<!-- 放置二维码的容器,需要给一个ref -->
    <div id="qrcode" ref="qrcode"></div>
</div>
</el-dialog>


    </div>
</template>
<script>
import {getPrechargeOrderList, addPrechargeOrder, alipayParam,exportOrderInfos} from '@/api/order.js'
import common from '@/utils/common.js'
// 引入
import QRCode from 'qrcodejs2'

export default {
    
    data(){
        return {
            payment:'微信扫码即可付款',
            qrcode:'',
            innerVisible:false,
            searchForm: {
                agentName: '',
                time: ''
            },
            
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },

            priceRmb:'',
            AliPayVisible: false,

            
        }
    },
    methods: {
          exportOrderInfoHandle(){
            common.deleteSpaceKey(this.searchForm); 

            this.$confirm('确定导出吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                exportOrderInfos(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(() => {

            });
        },
        formatPrice(){
            this.priceRmb = this.priceRmb.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1');
        },
        getPrechargeOrderListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getPrechargeOrderList(data).then(res => {
                common.listCallback(this, res, 'tbpg'); 
            })
        },
 
  // 生成二维码
  crateQrcode () {
    this.qr = new QRCode('qrcode', {
      width: 150,
      height: 150, // 高度
      text: this.qrcode // 二维码内容
      // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      // background: '#f0f'
      // foreground: '#ff0'
    })
    // console.log(this.qrcode)
  },
  // 关闭弹框,清除已经生成的二维码
  closeCode () {
    this.$refs.qrcode.innerHTML = ''
  },
         //微信支付
          doAddOrder(){
            let data = {
                priceRmb:this.priceRmb,
            }
             common.sysRequest('bindPhone/buy/sim/price', {}, 'post').then(res => {
                if(res.data.code == 200){
                    let result =res.data.data;
                     let sale =this.priceRmb*result.invent;
                 this.$confirm("本次充值手续费需要"+sale+"元，确定要充值吗？", "温馨提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                
            addPrechargeOrder(data).then(res => {
                if (res.data.code == 200) {
                  // window.location.href=
                  this.innerVisible = true
    // 二维码内容,一般是由后台返回的跳转链接,这里是写死的一个链接
      this.qrcode =res.data.data.code_url;
    // 使用$nextTick确保数据渲染
    this.$nextTick(() => {
      this.crateQrcode()
    })
                }else{
                    this.$message.error(res.data.message);
                    
                }

                this.priceRmb = '';
                this.AliPayVisible = false;
            })
            }).catch(() => {
                
            });
                }
            })


        },
        // doAddOrder(){  支付宝
        //     let data = {
        //         priceRmb:this.priceRmb,
        //     }
        //     addPrechargeOrder(data).then(res => {
        //         if (res.data.code == 200) {
        //             let fm = new FormData();
        //             fm.append("id", res.data.data.id);
        //             alipayParam(fm).then(newres => {
        //                 if (newres.data.code == 200) {
        //                     let routerData = this.$router.resolve({path:'/AliPay',query:{ htmlData: newres.data.data}});
        //                     // if (!!window.ActiveXObject || "ActiveXObject" in window) {
        //                     //     window.open(routerData.href, '_blank');
        //                     // }else{
        //                         window.open(routerData.href, '_blank');
        //                     // }
        //                 }
        //             })
        //         }else{
        //             this.$message.error(res.data.message);
                    
        //         }

        //         this.priceRmb = '';
        //         this.AliPayVisible = false;
        //     })
        // },

        cancelToPay(){
            this.priceRmb = '';
            this.AliPayVisible = false;
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPrechargeOrderListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPrechargeOrderListHandler();
        }  
    },
    created () {
        this.getPrechargeOrderListHandler();
    }  
}
</script>
<style lang="less" scoped>
    .AliPayIcon{
        div{
            width:200px;
            margin: 0 auto;
            margin-bottom: 30px;

            img{ width: 100%;}
        }
    }

    

    


    .priceDiv{
        margin-top: 20px;
        margin-bottom:50px;
        display: flex;

        .priceIcon{
            display: inline-block;
            flex: 1;
            height:35px;
            width:50px;
            line-height:35px;
            font-size:24px;
            border-bottom:1px solid #000;
            text-align: center;
        }

        .priceRmbInput{
            line-height:35px;
            flex: 5;
            height:35px;
            font-size: 28px;
            outline:none;
            border: none;
            border-bottom: 1px solid #000;
        }

        input:-ms-input-placeholder {
            font-size: 14px;
        }

        input::-moz-input-placeholder {
            font-size: 14px;
        }

        input::-webkit-input-placeholder {
            font-size: 14px;
        }

        input:-moz-placeholder{font-size: 14px;}                 
        input::-moz-placeholder{font-size: 14px;}                
        input:-ms-input-placeholder{font-size: 14px;}  

    }



    .topUpBtn{
        display: inline-block;
        width: 100%;
        height: 35px;
        line-height: 35px;
        text-align: center;
        border-radius: 5px;
        color: #fff;
        background: #3a8ee6;
    }
</style>

